import { disableAnimationClass, transition } from '@helpers/animate';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { h4 } from '@helpers/typography';
import ArrowSvg from '@img/icons/arrow-right.svg';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled.div ``;
const Item = styled(m.div) `
  margin-bottom: ${fluid(10, 10)};
  border-bottom: 1px solid var(--fgColour);
`;
const ItemHeader = styled.button `
  ${ButtonReset};

  display: flex;
  align-items: center;
  font-size: ${fluid(18, 28)};
  line-height: ${fluid(22, 36)};
  letter-spacing: -0.024em;
  margin: 0;
  text-align: left;
  width: 100%;
  scroll-margin: calc(var(--stickyHeaderHeight) + 26px) 0 0;

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-style: solid;
    outline-width: 2px;
  }
`;
const ItemTitle = styled.h3 `
  ${h4};
  margin-bottom: 15px;
  display: block;
  flex: 1 1 auto;
  color: var(--fgColour);
`;
const ItemIcon = styled(ArrowSvg) `
  ${transition('transform')};
  position: relative;
  top: -5px;
  display: block;
  width: 100%;
  max-width: ${fluid(20, 20)};
  height: ${fluid(12, 12)};
  transform: rotate(90deg);
  color: var(--fgColour);

  ${ItemHeader}:hover & {
    transform: translateY(5px) rotate(90deg);
  }

  ${ItemHeader}[aria-expanded='true'] & {
    transform: rotate(-90deg);
  }

  ${ItemHeader}[aria-expanded='true']:hover & {
    transform: translateY(-5px) rotate(-90deg);
  }
`;
const ItemTitleIcon = styled.span ``;
const ItemBody = styled(m.div) `
  min-width: 0;
  overflow: hidden;

  ${disableAnimationClass} & {
    height: 0 !important;
  }

  [data-open='true'] & {
    ${disableAnimationClass} & {
      height: auto !important;
    }
  }
`;
const ItemBodyInner = styled.div `
  padding-bottom: ${fluid(15, 25)};
`;
export default {
    Container,
    Item,
    ItemBody,
    ItemBodyInner,
    ItemHeader,
    ItemIcon,
    ItemTitle,
    ItemTitleIcon,
};
